import { useEffect, useRef, useState } from 'react'

export const useHeadlineObserver = (id: string) => {
	const observer = useRef<IntersectionObserver>()
	const [activeId, setActiveId] = useState('')

	useEffect(() => {
		const handleObsever = (entries) => {
			entries.forEach((entry) => {
				if (entry?.isIntersecting) {
					setActiveId(entry.target.id)
				}
			})
		}

		observer.current = new IntersectionObserver(handleObsever, {
			rootMargin: '0% 0% -85% 0px',
		})

		const elements = document.getElementById(id).querySelectorAll('h2, h3, h4')
		elements.forEach((elem) => observer.current.observe(elem))
		return () => observer.current?.disconnect()
	}, [])

	return { activeId }
}
